import { Component, OnInit } from '@angular/core';
import { NotificationService } from 'src/app/Core/services/notification.service';
import { ConfirmationDialogComponent } from '../../confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToasterService } from 'src/app/Core/services/toaster.service';

@Component({
  selector: 'app-notification-list',
  templateUrl: './notification-list.component.html',
  styleUrls: ['./notification-list.component.css']
})
export class NotificationListComponent implements OnInit {
  notifications: any[] = [];
  dateFormat: string;
  currentDate: Date;
  timeZoneOffset: string;

  constructor(
    private notificationService: NotificationService,  
    private dialog: MatDialog, 
    private router: Router, 
    private toaster: ToasterService
  ) { }

  ngOnInit(): void {
    this.getNotifications();
    this.dateFormat = 'dd MMM yyyy h:mm:ss a zzzz'
    this.getTimeZone();
  }

  getTimeZone() {
    this.currentDate = new Date();
    this.timeZoneOffset = this.getFormattedTimeZoneOffset(this.currentDate);
  }

  getFormattedTimeZoneOffset(date: Date): string {
    const offset = date.getTimezoneOffset();
    const absoluteOffset = Math.abs(offset);
    const hours = Math.floor(absoluteOffset / 60);
    const minutes = absoluteOffset % 60;
    const formattedOffset = (offset < 0 ? '+' : '-') + 
        this.padZero(hours) + ':' + this.padZero(minutes);
    return 'GMT' + formattedOffset;
  }

  padZero(value: number): string {
    return value < 10 ? '0' + value : value.toString();
  }

  getNotifications() {
    this.notificationService.listNotification().subscribe(
      (response: any[]) => {
        this.notifications = response;
      },
      error => {
        console.error('Failed to list notification', error);
        if (error.status === 403) {
          this.toaster.openDialogBox("You are unauthorized to access this page", true);
        }
      }
    );
  }

  getLanguages(notification: any): string[] {
    return Object.keys(notification.push);
  }

  test(notification: any) {
    this.notificationService.setNotificationData(notification);
    this.router.navigate(["/test-notification"]);
  }

  release(id: string) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: { confirmationText: 'Are you sure you want to release this notification?' }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        this.notificationService.releaseNotification(id).subscribe({
          next: (response) => {
            this.toaster.openDialogBox("Notification released to all users", false);
            this.getNotifications();
          },
          error: (error) => {
            console.error("Error releasing the notification", error);
            if (error.status === 400) {
              this.toaster.openDialogBox("This notification is already released", false);
            }
            if (error.status === 403) {
              this.toaster.openDialogBox("You don't have the required permission", false);
            }
          }
        });
      }
    });
  }

  delete(id: string) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: { confirmationText: 'Are you sure you want to delete this notification?' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        this.notificationService.deleteNotification(id).subscribe({
          next: (response) => {
            this.toaster.openDialogBox("Notification deleted successfully", false);
            this.getNotifications();
          },
          error: (error) => {
            console.error("Error deleting notification:", error);
            if (error.status === 403) {
              this.toaster.openDialogBox("You don't have the required permission", false);
            }
          }
        });
      }
    });
  }

  update(notification: any) {
    this.notificationService.setNotificationData(notification); // Save notification in localStorage and shared service
    this.router.navigate(["/edit-notification"]);
  }
}
